module.exports = {"name":"Logo","description":"Logo block","fields":[{"name":"size","type":"hidden"}]}


//////////////////
// WEBPACK FOOTER
// ./components/blocks/definitions/logo.json
// module id = 694
// module chunks = 185 187